SNI.Application.addModule('related-classes', (context) => {
  return {
    behaviors: ['lazy-load','truncate']
  };
});
